export var isUnlimitedSpeakingValue = function isUnlimitedSpeakingValue(value) {
  return value === undefined || value === null || value === -1 || value === 0;
};
export var normalizeUnlimitedSpeakingValue = function normalizeUnlimitedSpeakingValue(value) {
  return isUnlimitedSpeakingValue(value) ? -1 : value;
};